import { render, staticRenderFns } from "./MessageRegisterQueue.vue?vue&type=template&id=48bcfc0a&scoped=true"
import script from "./MessageRegisterQueue.vue?vue&type=script&lang=js"
export * from "./MessageRegisterQueue.vue?vue&type=script&lang=js"
import style0 from "./MessageRegisterQueue.vue?vue&type=style&index=0&id=48bcfc0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bcfc0a",
  null
  
)

export default component.exports